<template>
  <PopulationSharingModal
    v-model:selected-population-ids="selectedPopulationIds"
    :is-new-population="isNewPopulation"
    @close="onClose"
    @saved="onClose"
  />
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import PopulationSharingModal from '@/components/partners/DataSharingSettings/PopulationSharingModal/PopulationSharingModal.vue';

import usePopulations from '@/composables/usePopulations';

const route = useRoute();
const router = useRouter();

const { allPopulations, customPopsWithStatsAndSharing } = usePopulations();

const populationId = computed(() => {
  const id = route.params.population_id;
  return parseInt(typeof id === 'string' ? id : (id?.[0] ?? '0'));
});
const selectedPopulationIds = ref([populationId.value]);

const isNewPopulation = computed(() => route.query?.newPopulation === 'true');
const population = computed(() => {
  const populations = [
    ...allPopulations.value,
    ...customPopsWithStatsAndSharing.value,
  ];
  return populations.find((population) => population.id === populationId.value);
});

useHead({
  title: computed(() => population.value?.name ?? ''),
  titleTemplate: 'Edit - %s - Sharing Settings - Crossbeam',
});

async function onClose() {
  await router.push({ name: 'populations' });
}

watch(populationId, (id) => {
  selectedPopulationIds.value = [id];
});
</script>
